export const MOTION_TRACK_PLAYBACK_RATE = 3;

export const getSightingVideoPlaybackRate = (isMotionTrack) => (
  isMotionTrack ? MOTION_TRACK_PLAYBACK_RATE : 1
);

export const getMotionTrackUrl = (entry) => {
  const candidates = [entry?.motionTrackUrl, entry?.motionTrack?.url];
  const url = candidates.find((value) => typeof value === 'string' && value.trim());
  return url ? url.trim() : null;
};

export const matchesSightingMediaFilter = (entry, mediaTypeFilter) => {
  if (!mediaTypeFilter || mediaTypeFilter === 'all') {
    return true;
  }

  if (mediaTypeFilter === 'motion-track') {
    return Boolean(getMotionTrackUrl(entry));
  }

  return entry?.mediaType === mediaTypeFilter;
};
